import {Pressable, Text} from "@hosttools/frontend/components";
import type React from "react";
import {memo, useCallback} from "react";
import {useHistory} from "react-router-dom";

import {ReactComponent as ReferralIcon} from "@/admin/img/referral-icon-gradient.svg";

const ReferralButton: React.FC = () => {
    const history = useHistory();

    const handleClick = useCallback(() => {
        history.push("/settings/referral");
    }, [history]);

    return (
        <Pressable
            className="p-2 flex-row items-center gap-2 bg-blue-50 rounded-md"
            onPress={handleClick}
        >
            <ReferralIcon height={16} width={16} />
            <Text className="hidden md:block" color="blueGray.800" variant="sm">
                Invite Friends
            </Text>
        </Pressable>
    );
};

export default memo(ReferralButton);
